import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
const useStyles = makeStyles((theme) => ({
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    cardMedia: {
      paddingTop: '56.25%', // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(6),
    },
  }));
  

const Newsletter=(props)=> {
    
    const classes = useStyles();
    const onError = (e) => {
      console.log(e, 'error in file-viewer');
    }
    const file = 'https://www.docdroid.net/8vWf4AN/iv-abraham-2-pdf'
    const type = 'pdf'
    return (
        <div>
            <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <h1 style={{fontSize:"50px",textAlign:"left"}}>Books</h1>
            <iframe src="https://www.docdroid.net/8vWf4AN/iv-abraham-2-pdf"  width="100%" height="500" title="PDF"></iframe>
        </Container>
        <br/>
        {/* {admin === true ? 
        <Card style={{margin:"auto"}}>
        <input type="file" onChange={selectFileHandler} id="upload-button" />

<Button
    onClick={uploadFileHandler}
    variant="contained"
    color="primary"
    // className="uploadButton"
    startIcon={<CloudUpload />}
>
    Upload
</Button>
<br/>
<progress value={progress} max="100" />
                <br />
        </Card>
        : <div/>} */}
        </div>
    )
}
export default Newsletter;

// After CardMedia
